import { useRequisitions } from '@hook'
import { RequisitionItem } from '@type/requisitions.type'
import { DeleteModal as SubmitModal } from '@ui'
import { getError, showToast } from '@util'
import { useState } from 'react'

type Props = {
  onClose: () => void
  requisitionId?: string
  selectedItems?: RequisitionItem[]
}

export const ApproveAllRequisitions = ({ onClose, requisitionId = '', selectedItems = [] }: Props) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { reviewRequisition } = useRequisitions()

  const submit = async () => {
    if (!requisitionId || selectedItems.length === 0) {
      showToast('No pending requisition selected')
      return
    }

    setIsSubmitting(true)
    try {
      await reviewRequisition({
        id: requisitionId,
        payload: {
          data: {
            type: 'requisition',
            attributes: {
              items: selectedItems.map(item => ({
                approved_quantity: String(Number(item.requested_quantity || item.approved_quantity || 0)),
                id: String(item.id),
                status: 'approved'
              }))
            }
          }
        }
      })

      showToast('Requisition item(s) approved successfully')
      onClose()
    } catch (error) {
      getError(error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <SubmitModal
      description="Are you sure you want to approve all items in this requisition?"
      handleSubmit={submit}
      isLoading={isSubmitting}
      lBtnLabel="Cancel"
      noIcon
      onClose={onClose}
      rBtnLabel="Approve"
      title="Approve Requisition"
    />
  )
}
